const roommateCountOptionItems = [
  {
    value: 0,
    label: 'Just me',
  },
  {
    value: 1,
    label: '1 other adult',
  },
  {
    value: 2,
    label: '2 other adults',
  },
  {
    value: 3,
    label: '3 other adults',
  },
  {
    value: 4,
    label: '4 other adults',
  },
];

export default roommateCountOptionItems;
